// extracted by mini-css-extract-plugin
module.exports = {"specialty":"specialty","specialty__item":"specialty__item","specialtyItem":"specialty__item"};